<template>
    <div class="merchant-routing-rules">
        <div class="merchant-routing-rules__header">
            <h1>Merchant Routing Rules</h1>
            <Button buttonName="Set Specific Rule" :onClick="handleRedirect" classes="primary"  />
        </div>
        <div>
           <Table :contents="contents.rules" :hidePagination="true"  :hideTableTop="true" :loading="contents.loading" darkenAll>     
               <template v-slot:nocontent>	
                    <h1>No Routing Rules</h1>
                    <p>All routing rules will show here</p>
                </template>
           </Table>
        </div>
    </div>
</template>
<script>
import { reactive, onBeforeMount, computed, watch } from '@vue/composition-api'
import Table from "@/components/table.vue"
import Button from "@/components/button.vue"
import RoutineRule from "@/components/routingrule.vue"
import { deleteFromArrayOfObject, addToArray, modifyArrayById } from "@/lib/arrayManipulation"

export default {
    components: {
        Button,
        RoutineRule,
        Table
    },
    setup(props, { root }) {
        const store = root.$store;
        const params = root.$route.params;
        const contents = computed(() => store.getters.getMerchantSpecificRoutingRules);

        onBeforeMount(() => {
            store.dispatch('getMerchantRoutingRules', { merchant_id: `${params.id}` })
        })

        watch(() => root.$route.params, () => {
            store.dispatch('getMerchantRoutingRules', { merchant_id: `${params.id}` })
        })

        const handleRedirect = () => {
            root.$router.push({  name: 'modify-merchant-routine-rule' })
        }

    
        return {
            contents,
            handleRedirect
        }
    }
}
</script>
<style lang="scss">
.merchant-routing-rules {
    width: 100%;

    .btn {
       width: 169px;
       height: 40px;
       justify-content: center;

       .btn--text {
           font-size: 15px;
       }
    }

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 55px 55px;


        h1 {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 14px;
        }
    }

    .table-component {
        border: none;
        margin: 0;
        margin-bottom: 50px;
        box-shadow: none;

        .table {
            th, td {
                padding: 13px 54px;
            }
        }

        .no-content {
            padding: 90px 26px;
        }
    }
}
</style>